module.exports = __webpack_public_path__ + "static/media/wave_gray_up.10eaa429.svg";